import React, { useEffect, useState } from "react";
import AddAddress from "../../components/Forms/AddAddress";
import { AddressFetchApi } from "../../ApiCalls/Address";
import { FaMinus, FaPlus } from "react-icons/fa";

function ProfileAddAddress() {
  const [isAddressOpen, setIsAddressOpen] = useState(true);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [fetchedAddress, setFetchedAddress] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addressToEdit, setAddressToEdit] = useState(null);
  const [success, setSuccess] = useState(false);

  const fetchAddressData = async () => {
    try {
      const addressData = await AddressFetchApi();
      setFetchedAddress(addressData.data);
    } catch (error) {
      console.error("Failed to fetch address data:", error);
    }
  };

  useEffect(() => {
    fetchAddressData();
  }, []);

  const handleEditClick = (address) => {
    setAddressToEdit(address);
    setIsModalOpen(true);
  };

  const handleCancelEdit = () => {
    setAddressToEdit("");
    setIsModalOpen(false);
  };

  return (
    <div className="h-auto w-full rounded-2xl bg-white p-10">
      {isAddressOpen && (
        <div className="transform p-4 transition-all duration-1000">
          {/* Address Selection Options */}
          {fetchedAddress.map((address) => (
            <div key={address.id} className="mb-2 flex items-start gap-3">
              <div
                className={`md:w flex w-full cursor-pointer items-center gap-5 rounded border p-2 ${selectedAddress === address.id
                    ? "border-red-300 bg-red-200"
                    : "border-gray-200 bg-white"
                  }`}
              >
                <label htmlFor={address.id} className="cursor-pointer text-left">
                  <h3 className="text-sm font-medium">{address.name}</h3>
                  <p className="text-xs">
                    {address.housename}, {address.city}, {address.state},{" "}
                    {address.pincode}, {address.landmark}
                  </p>
                </label>
              </div>
              <div className="mt-5">
                <button
                  className="h-min w-16 rounded border border-gray-300 p-1 text-sm text-gray-600"
                  onClick={() => handleEditClick(address)}
                >
                  Edit
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="flex flex-col text-brand-primary">
        <h1 className="pt-4 text-[20px] font-semibold">
          {addressToEdit ? "Edit Address" : "Add Address"}
        </h1>
      </div>
      <AddAddress
        headHidden={false}
        closeModal={() => {
          setIsModalOpen(false);
          handleCancelEdit();
        }}
        onAddressAdded={() => {
          fetchAddressData();
          handleCancelEdit();
        }}
        addressToEdit={addressToEdit}
      />
      {addressToEdit && (
        <button
          className="mt-4 rounded bg-red-500 px-4 py-2 text-white"
          onClick={handleCancelEdit}
        >
          Cancel Edit
        </button>
      )}
    </div>
  );
}

export default ProfileAddAddress;
